import api from '@/services/api.service';

function unwrap<T>(res: unknown): T {
  const data = (res as { data?: unknown })?.data ?? res;
  return ((data as { data?: unknown })?.data ?? data) as T;
}

export interface WarehouseLocation {
  id: string;
  company_id?: string | null;
  warehouse_id: string;
  location_code: string;
  location_name: string;
  parent_location_id?: string | null;
  location_type?: string;
  capacity_quantity?: number;
  capacity_weight?: number;
  capacity_volume?: number;
  is_active?: boolean;
  is_deleted?: boolean;
  created_at?: string;
  updated_at?: string;
}

export interface WarehouseLocationInput {
  location_code: string;
  location_name: string;
  parent_location_id?: string | null;
  location_type?: string;
  capacity_quantity?: number;
  capacity_weight?: number;
  capacity_volume?: number;
  is_active?: boolean;
}

export interface PutawayInput {
  warehouse_id: string;
  item_id: string;
  from_location_id?: string | null;
  to_location_id: string;
  quantity: number;
  uom: string;
  heat_number?: string | null;
  dimension?: string | null;
  ownership_type?: string | null;
  owner_customer_id?: string | null;
  owner_supplier_id?: string | null;
  remarks?: string | null;
}

export interface PutawayResult {
  voucherId: string;
  voucherNumber: string;
}

class WarehouseLocationService {
  async listByWarehouse(warehouseId: string): Promise<WarehouseLocation[]> {
    const res = await api.getClient().get(`/inventory/warehouses/${warehouseId}/locations`);
    const data = unwrap<WarehouseLocation[]>(res);
    return Array.isArray(data) ? data : [];
  }

  async create(warehouseId: string, body: WarehouseLocationInput): Promise<WarehouseLocation> {
    const res = await api.getClient().post(`/inventory/warehouses/${warehouseId}/locations`, body);
    return unwrap<WarehouseLocation>(res);
  }

  async update(id: string, body: Partial<WarehouseLocationInput>): Promise<WarehouseLocation> {
    const res = await api.getClient().put(`/inventory/warehouse-locations/${id}`, body);
    return unwrap<WarehouseLocation>(res);
  }

  async remove(id: string): Promise<void> {
    await api.getClient().delete(`/inventory/warehouse-locations/${id}`);
  }

  async putaway(body: PutawayInput): Promise<PutawayResult> {
    const res = await api.getClient().post('/inventory/stock/putaway', body);
    return unwrap<PutawayResult>(res);
  }
}

export default new WarehouseLocationService();
